import React from "react";
import { Card, Descriptions, Button, Tag, Space, Empty, Image } from "antd";
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { ENDPOINTS } from "../../Services/ENDPOINT";

const RoomDetail = ({ room, onEdit, handleEditRoom, handleDelete }) => {

  console.log(room);

  if (!room) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        borderRadius: '12px',
        color: '#8c8c8c',
        fontSize: '16px',
        fontWeight: 500
      }}>
        <Empty description="No rooms found!" />
      </div>
    );
  }

  // Safely parse images — handles both string and array
  const images = (() => {
    try {
      const parsed = typeof room.images === "string" ? JSON.parse(room.images) : room.images;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  })();

  // Safely parse amenities
  const amenities = (() => {
    try {
      const parsed = typeof room.amenities === "string" ? JSON.parse(room.amenities) : room.amenities;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  })();

  return (
    <Card
      className="room-detail-card"
      title="Room Details"
      extra={
        <Space size="small">
          <Button
            danger
            icon={<DeleteOutlined />}
            className="detail-action-btn detail-delete-btn"
            onClick={() => handleDelete()}
          >
            Delete
          </Button>
          <Button
            type="primary"
            icon={<EditOutlined />}
            className="detail-action-btn detail-edit-btn"
            onClick={() => {
              onEdit(room);
              handleEditRoom();
            }}
          >
            Edit
          </Button>
        </Space>
      }
    >
      {/* ── Images ── */}
      {images.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <Image.PreviewGroup>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {images.map((src, index) => (
                <Image
                  key={index}
                  src={`${ENDPOINTS.cleanBase}${src}`}
                  alt={`Room image ${index + 1}`}
                  width={120}
                  height={90}
                  style={{ objectFit: 'cover', borderRadius: 8, border: '1px solid #f0f0f0' }}
                />
              ))}
            </div>
          </Image.PreviewGroup>
        </div>
      )}

      {room.room_name && (
        <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: '12px 14px', marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#000000ff', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 6 }}>Room Name</div>
          <div style={{ fontSize: 15, color: '#595959', lineHeight: 1.7 }} >{room.room_name}</div>
        </div>
      )}

      {/* ── Stats Grid ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 12 }}>
        {[
          { label: 'Type', value: room.room_type },
          { label: 'Floor', value: room.floor },
          { label: 'Online Booking Price', value: `₹${room.online_price || " Not Added"}`, green: true },
          { label: 'Price / Day', value: `₹${room.price_per_day}`, green: true },
          { label: 'AC Charge', value: `₹${room.ac_charge}`, green: true },
          { label: 'Max Occupancy', value: `${room.max_occupancy} persons` },
          { label: 'Price / Hour', value: `₹${room.price_per_hour || " Not Added"}`, green: true },
          { label: '24 Hours Booking', value: `₹${room.additional_24_hour || " Not Added"}`, green: true },
          {
            label: 'Child Age Limit',
            value:
              room?.child_age_limit !== null &&
                room?.child_age_limit !== undefined &&
                room?.child_age_limit !== ''
                ? `${room.child_age_limit} years`
                : 'Not Added',
          },
          {
            label: 'Child Cost Per Person',
            value:
              room?.child_cost_per_person !== null &&
                room?.child_cost_per_person !== undefined &&
                room?.child_cost_per_person !== ''
                ? `₹${room.child_cost_per_person}`
                : 'Not Added',
            green: true,
          },
        ].map(({ label, value, green }) => (
          <div key={label} style={{ background: '#fafafa', borderRadius: 8, padding: '10px 14px' }}>
            <div style={{ fontSize: 11, color: '#000000ff', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 14, fontWeight: 500, color: green ? '#389e0d' : '#1a1a1a' }}>{value}</div>
          </div>
        ))}

        {/* Status gets its own pill */}
        <div style={{ background: '#fafafa', borderRadius: 8, padding: '10px 14px' }}>
          <div style={{ fontSize: 11, color: '#000000ff', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 6 }}>Status</div>
          <Tag color={room.status === 'available' ? 'success' : 'error'} style={{ borderRadius: 99 }}>
            {room.status.toUpperCase()}
          </Tag>
        </div>
      </div>

      {/* ── Amenities ── */}
      {amenities.length > 0 && (
        <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: '12px 14px', marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#000000ff', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 8 }}>Amenities</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {amenities.map((item, i) => (
              <Tag color='blue' key={i} style={{ borderRadius: 99, margin: 0 }}>{item}</Tag>
            ))}
          </div>
        </div>
      )}

      {/* ── Description ── */}

      {room.description && (
        <div style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: '12px 14px', marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#000000ff', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 6 }}>Description</div>
          <div style={{ fontSize: 13, color: '#595959', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: room.description }} />
        </div>
      )}

      {/* ── Timestamps ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 10, borderTop: '1px solid #f0f0f0' }}>
        <span style={{ fontSize: 12, color: '#000000ff' }}>Added: {room.added_on}</span>
        <span style={{ fontSize: 12, color: '#000000ff' }}>Updated: {room.updated_on}</span>
      </div>
    </Card>
  );
};

export default RoomDetail;